import { render } from "./UploadSelfieForm.vue?vue&type=template&id=f9db45b0"
import script from "./UploadSelfieForm.vue?vue&type=script&lang=js"
export * from "./UploadSelfieForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__